import { render, staticRenderFns } from "./VaimoSidebar.vue?vue&type=template&id=257d8e1c&"
import script from "./VaimoSidebar.vue?vue&type=script&lang=ts&"
export * from "./VaimoSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoSidebar.vue?vue&type=style&index=0&id=257d8e1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports